import React from 'react';
import TextCell from 'app/components/data-table/TextCell';
import TimestampCell from 'app/components/data-table/TimestampCell';
import buildSortNumber from 'app/event-monitoring/event-schemas/EventSchemaTable/buildSortNumber';

const eventSchemaTableColumns = [
  {
    id: 'eventName',
    name: 'Event Name',
    selector: row => row.eventName,
    cell: row => <TextCell bubbleClickEvent text={row.eventName} />,
    sortable: true,
    width: '20rem',
  },
  {
    id: 'pipelineNames',
    name: 'Pipelines',
    selector: row => row.pipelineNames,
    cell: row => <TextCell bubbleClickEvent text={row.pipelineNames} />,
    sortable: true,
  },
  {
    id: 'lastSeen',
    name: 'Last Seen',
    selector: row => row.lastSeen,
    cell: row => <TimestampCell bubbleClickEvent timestamp={row.lastSeen?.toISOString()} />,
    sortable: true,
    width: '15rem',
  },
  {
    id: 'combinations',
    name: 'Combinations',
    selector: row => buildSortNumber(row.combinations),
    cell: row => <TextCell bubbleClickEvent text={row.combinations} />,
    sortable: true,
    width: '10rem',
  },
  {
    id: 'totalCount',
    name: 'Sample Count',
    selector: row => buildSortNumber(row.totalCount),
    cell: row => <TextCell bubbleClickEvent text={row.totalCount} />,
    sortable: true,
    width: '10rem',
  },
];

export default eventSchemaTableColumns;
